import React, { useEffect, useState } from 'react';
import { Provider } from 'mobx-react'; // TODO: remove mobx
import { Route, Switch, useHistory } from 'react-router-dom';
import queryString from 'query-string';
import AngularApp from './AngularApp';
import i18n from '../lib/i18next';

// Receipts
import './Receipts'; // initialize react component for angular usage
import ReceiptViewer from './ReceiptViewer';
// Store for
import categoriesModel from '../models/categories';
import receiptViewerModel from '../models/receiptViewer';
import receiptsModel from '../models/receipts';

import { useHealthStatus } from '../contexts/healthStatus';
import MaintenancePage from './MaintenancePage';
import ErrorPage from './ErrorPage';
import { useAuth } from '../contexts/auth';
import OnboardingInstitutionManager from './OnboardingInstitutionManager';
import GrowSubscriptionComplete from './GrowSubscriptionComplete';
import useGuestInfo from '../hooks/useGuestInfo';
import useMixpanel from '../hooks/useMixpanel';
import { checkoutSessionInfo } from '../services/checkoutSessionInfo';
import { SUBSCRIPTIONS_MAP } from '../services/App/App.constants';

const ROUTES = {
  ONBOARDING_INSTITUTIONS: '/onboarding/institutions',
  SUBSCRIBED_GROW: '/subscribed/grow'
}

export default function ReactApp() {
  useMixpanel();
  const history = useHistory();
  const [appReady, setAppReady] = useState(false);

  const { accessTokenInfo } = useAuth();
  const guestInfo = useGuestInfo();
  const { maintenance, error } = useHealthStatus();

  useEffect(() => {
    if (!guestInfo || !accessTokenInfo) {
      return;
    }

    if (maintenance || error) {
      return;
    }

    if (accessTokenInfo) {
      i18n.changeLanguage(accessTokenInfo.guest.lang);
    }

    const parsed = queryString.parse(
      window.location.search || window.location.hash
    );

    // Extract redirect path from state (set during myAccount login)
    const redirectPath = parsed.state && JSON.parse(parsed.state).path;

    if (!redirectPath) {
      setAppReady(true);
      return;
    }

    // Check for Stripe checkout session in the redirect path
    const pathQuery = redirectPath.split('?')[1];
    const checkoutSessionId = pathQuery
      ? queryString.parse(pathQuery)['subscription-session']
      : null;

    // Determine final destination path (strip query params)
    const finalPath = redirectPath.split('?')[0];

    // If no checkout session, navigate immediately
    if (!checkoutSessionId) {
      history.push(finalPath);
      setAppReady(true);
      return;
    }

    // Process Stripe checkout session and enable subscription if valid
    checkoutSessionInfo(checkoutSessionId).then((result) => {
      if (result && result.guest_uid === guestInfo.uid && result.is_subscribed) {
        window.subscriptionLevel = SUBSCRIPTIONS_MAP[result.product_key];
      }

      // See SUBSCRIPTIONS_MAP for the keys
      if (window.subscriptionLevel === SUBSCRIPTIONS_MAP.grow) {;
        history.push(ROUTES.SUBSCRIBED_GROW);
      } else if (!guestInfo.credentials.length) {
        // After subscription, if guest has no connected institutions, always redirect to onboarding
        history.push(ROUTES.ONBOARDING_INSTITUTIONS);
      } else {
        history.push(finalPath);
      }

      setAppReady(true);
    });
  }, [guestInfo, accessTokenInfo, maintenance, error, history]);

  if (maintenance) {
    return <MaintenancePage />;
  }

  if (error) {
    return <ErrorPage />;
  }

  return (
    appReady && (
      <>
        <Switch>
          <Route
            path={ROUTES.ONBOARDING_INSTITUTIONS}
            component={OnboardingInstitutionManager}
          />
          <Route
            path={ROUTES.SUBSCRIBED_GROW}
            component={() => <GrowSubscriptionComplete locale={accessTokenInfo.guest.lang} />}
          />
          <Route component={AngularApp} />
        </Switch>
        <Provider
          receiptViewerModel={receiptViewerModel}
          receiptsModel={receiptsModel}
          categoriesModel={categoriesModel}
        >
          <ReceiptViewer baseCurrency={guestInfo.baseCurrency} />
        </Provider>
      </>
    )
  );
}
